import "antd/dist/antd.less";
import "assets/style/main.less";

import { hot } from "react-hot-loader/root";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import * as RouteConfiguration from "./routes";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";

import { notification } from "antd";
import { NavigationBar } from "components/general";
import { RouteComponentProps } from "react-router";

// Store Route Configuration
// (Must Be Mutable For Hot Reloading To Function)
const routes = RouteConfiguration.routes;

function renderApp() {

	// Register FontAwesome Icons
	library.add(fab, fas, far);

	// Configure Notifications
	notification.config({
		placement: "bottomRight",
		duration: 5
	});

	// Get Application Url (Injected By ASP.NET)
	const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string | undefined;

	// Define Application
	const application = () => (

		<BrowserRouter basename={baseUrl}>
			<div>
				<Route path="*" component={(props: RouteComponentProps<any>) => <NavigationBar className="navigation" {...props} />} />
				{routes}
			</div>
		</BrowserRouter>
	);

	// Enable Hot Reloading
	const HotApplication = hot(application);

	// Start React Application
	ReactDOM.render(<HotApplication />, document.getElementById("react-app"));
}

// Launch Application
renderApp();
